angular.module 'app'
.controller 'RetrievePasswordCtrl', ($uibModalInstance, config, $scope, $stateParams, growl, $http, data, Storage) ->
  $scope.ui =
    email: ''

  $scope.cancel = ->
    $uibModalInstance.close 'Cancel'

  $scope.confirm = ->
    return growl.error "Please enter your account name (email address)" if $scope.ui.email == ''
    $http.post "#{config.eadmin.baseUrl}/reset",
      email: $scope.ui.email
      clientId: config.eadmin.clientId
    .success (res) ->
      return growl.success "New password has been sent to your e-mail, please pay attention to check"
    .error (err) ->
      return growl.error "Account name (email address) does not exist"
